import React, { Component } from 'react'

const Project = class extends Component {
  toggleDetails(elem) {

    const 
        projectContainer = this.parent(elem.target)
      , activeProject = document.querySelector('.project.active');

      if (projectContainer.classList.contains('active'))
        this.collapseDetails(projectContainer)
      else {
        if (activeProject)
          this.collapseDetails(activeProject)
        
        this.expandDetails(projectContainer)
      }
  }

  expandDetails(element) {
    const detailsContainer = element.querySelector('.details')

    element.classList.add('active')
    element.style.paddingBottom = `${detailsContainer.clientHeight}px`
  }

  collapseDetails(element) {
    element.classList.remove('active')
    element.style.paddingBottom = `0px`;
  }

  parent(element) {
    while (!element.classList.contains('project')) {
      element = element.parentNode
    }
    
    return element
  }

  render() {
    const {data} = this.props
    const {frontmatter} = data
    const {html} = data

    return (
      <section className="project">
        <header style={{ 'backgroundImage': `url(${frontmatter.hero.publicURL})` }}>
          <div className="inner">
            <h3>{frontmatter.title}</h3>
            <h4>{frontmatter.overview}</h4>
            <ul>
              <li>
                <button onClick={this.toggleDetails.bind(this)} >Details</button>
              </li>
              <li>
                {frontmatter.website&&
                <a href={frontmatter.website}>Website</a>
                }
                {!frontmatter.website&&
                <a href="javascript:void(0)">In development</a>
                }
              </li>
            </ul>
          </div>
        </header>
        <div className="details">
          <div className="wrapper story">
            <div>
              <h2>Project Details</h2>
            </div>
            <div dangerouslySetInnerHTML={{ __html: html }} />
            <div>
              {
                frontmatter.tags.length > 0 &&
                <div className="tags">
                  <h3>Services</h3>
                  <ul className="simple">
                    {frontmatter.tags.map((tag, index) => (                      
                      <li key={index}>{tag}</li>
                    ))}   
                  </ul>
                </div>
              }    

              {
                frontmatter.collaborators.length > 0 &&
                <div className="tags">
                  <h3>Collaborators</h3>
                  <ul className="simple">
                    {frontmatter.collaborators.map((item, index) => (
                      <li key={index}>
                        {item.website &&
                          <span>
                            {item.service} by<br />
                            <a href={item.website}>{item.name}</a>                        
                          </span>
                        }
                        {!item.website &&
                          <span>
                            {item.service} by<br />
                            {item.name}
                          </span>
                        }
                      </li>
                    ))}   
                  </ul>
                </div>
              }                      
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default Project



// WEBPACK FOOTER //
// ./src/components/project.js